import { render, staticRenderFns } from "./InvitationForm.vue?vue&type=template&id=a6d444a2&"
import script from "./InvitationForm.vue?vue&type=script&lang=js&"
export * from "./InvitationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports